import { NgModule, isDevMode, ErrorHandler, APP_INITIALIZER, inject } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { Router, RouteReuseStrategy } from '@angular/router';
import * as Sentry from '@sentry/angular';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { IonicStorageModule } from '@ionic/storage-angular';

import { TokenInterceptorService } from '@auth/services/token-interceptor.service';
import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule } from '@angular/common/http';
import { ClipboardModule } from 'ngx-clipboard';
import { CommonModule } from '@angular/common';

import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { ErrorInterceptorService } from '@auth/services/error-interceptor.service';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '@env/environment';
import { provideEnvironmentNgxMask } from 'ngx-mask';
import { SentryInterceptorService } from '@auth/services/sentry-interceptor.service';
import { ReactiveFormsModule } from '@angular/forms';
import { DROPZONE_CONFIG, DropzoneConfigInterface, DropzoneModule } from 'ngx-dropzone-wrapper';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { PropertyDetailsModule } from './owner/views/property/property-details/property-details.module';
import { LocalizationService } from './newapp/core/services/localization.service';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

const DEFAULT_DROPZONE_CONFIG: DropzoneConfigInterface = {
  // Configuration par défaut globale si nécessaire
};

function initializeApp(localizationService: LocalizationService) {
  return () => localizationService.initialize();
}

@NgModule({
  declarations: [AppComponent],
  imports: [
    AppRoutingModule,
    BrowserModule,
    DropzoneModule,
    CommonModule,
    IonicModule.forRoot({
      animated: true,
      innerHTMLTemplatesEnabled: true
    }),
    IonicStorageModule.forRoot(),
    HttpClientModule,
    ClipboardModule,
    TranslateModule.forRoot({
      defaultLanguage: 'fr',
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    PropertyDetailsModule,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.production
    }),
  ],
  providers: [
    {
      provide: RouteReuseStrategy,
      useClass: IonicRouteStrategy,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptorService,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorInterceptorService,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: SentryInterceptorService,
      multi: true,
    },
    {
      provide: DROPZONE_CONFIG,
      useValue: DEFAULT_DROPZONE_CONFIG
    },
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler(),
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    {
      provide: APP_INITIALIZER,
      useFactory: () => () => {},
      deps: [Sentry.TraceService],
      multi: true,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: initializeApp,
      deps: [LocalizationService],
      multi: true,
    }
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }
